import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const getSalesTimelineData = async ({ queryKey }) => {
  const [, docId, documentType, searchQuery] = queryKey;

  const { data } = await apiClient.get(`/sales-${documentType}/${docId}/peppol-status-logs`, { params: searchQuery });
  return data;
};

export const getPurchaseTimelineData = async ({ queryKey }) => {
  const [, docId, documentType, searchQuery] = queryKey;

  const { data } = await apiClient.get(`/purchase-${documentType}/${docId}/peppol-status-logs`, {
    params: searchQuery,
  });
  return data;
};

export const useGetTimelineDataHandler = (documentType, docId, isOpen, isPurchase, searchQuery = {}) => {
  const dispatch = useDispatch();
  const [timelineData, setTimelineData] = useState(undefined);
  const [lastFetchTime, setLastFetchTime] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [`timelineData-${documentType}`, docId, documentType, searchQuery],
    queryFn: isPurchase ? getPurchaseTimelineData : getSalesTimelineData,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
    enabled: isOpen,
  });

  useEffect(() => {
    if (fetchedData) {
      setTimelineData(fetchedData);
    }
    if (timelineData && timelineData.length > 0) {
      setLastFetchTime(Date.now());
    }
  }, [fetchedData, timelineData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || error.message,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: JSON.stringify(error),
            severity: 'error',
          }),
        );
      }
    }
  }, [dispatch, error, isError]);

  return {
    timelineData,
    isLoading,
    lastFetchTime,
  };
};
